import { IEoraAssetsProviderProps } from './themes/EoraThemeProvider';
import { frontendConfig } from '@cmctechnology/webinvest-constants';

export const getAssetsBaseUrl = (config?: IEoraAssetsProviderProps) => {
  if (config?.baseAssetsUrl) {
    return config?.baseAssetsUrl;
  }

  return `${frontendConfig[config?.currentEnv ?? 'production'].hostUrl}/webinvest-module-icons/v/latest`;
};

export const DEBOUNCE_TIME_ON_MOUSEOUT = 300;
